class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    // document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    // if (countContainer) {
    //   countContainer.classList.add('loading');
    // }
    // if (countContainerDesktop) {
    //   countContainerDesktop.classList.add('loading');
    // }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        // FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.customUpdate(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    // FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.customUpdate(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
    if (window.getCookie('grid-columns')) {
      let columns = JSON.parse(window.getCookie('grid-columns'));
      if (window.innerWidth < 990) {
        qs(`.grid-icons [data-columns="${columns[0]}"]`)?.click();
      }else {
        qs(`.grid-icons [data-columns="${columns[1]}"]`)?.click();
      }
    }else {
      if (theme.bannerHeight) theme.bannerHeight();
    }
    if ($th_refreshWishlistItems) $th_refreshWishlistItems();
  }

  static customUpdate(html) {
    const newHtml = new DOMParser().parseFromString(html, 'text/html');
    qs('.active-filter-js').innerHTML = qs('.active-filter-js',newHtml).innerHTML;
  }

  static renderProductCount(html) {
    // const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    // const container = document.getElementById('ProductCount');
    // const containerDesktop = document.getElementById('ProductCountDesktop');
    // const containerMobile = document.getElementById('ProductCountMobile');
    // container.innerHTML = count;
    // container.classList.remove('loading');
    // if (containerDesktop) {
    //   containerDesktop.innerHTML = count;
    //   containerDesktop.classList.remove('loading');
    // }
    // if (containerMobile) {
    //   containerMobile.innerHTML = count;
    //   containerMobile.classList.remove('loading');
    // }
    const innerHTML = new DOMParser()
    .parseFromString(html, 'text/html')
    .getElementById('main-collection-product-grid').innerHTML;

    document.getElementById('main-collection-product-grid').innerHTML = innerHTML;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const jsFilter = event ? event.target.closest('.js-filter') : undefined;
    let summary = qs('summary.mobile-facets__summary',jsFilter);
    let activeInput = Array.from(qsa('input.mobile-facets__checkbox',jsFilter)).find(input => input.checked);
    if (activeInput) {
      summary?.classList.add('active-filter');
    }else {
      summary?.classList.remove('active-filter');
    }
    const matchesIndex = (element) => {
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

      let selectedItems = document.querySelectorAll('.filter-selected-items');
      let parsedSelectedItems = parsedHTML.querySelectorAll('.filter-selected-items');
      selectedItems.forEach((item,i)=>{
          item.innerHTML = parsedSelectedItems[i].innerHTML;
      })

      let counts = document.querySelectorAll('.product-count__text')
      let countsParse = parsedHTML.querySelectorAll('.product-count__text')

      counts.forEach((count,i)=>{
        count.innerHTML = countsParse[i].innerHTML;
      })

      let nextBtn = document.querySelector('.paginate-load-more-wrap');
      let renderNextBtn = parsedHTML.querySelector('.paginate-load-more-wrap');
      console.log("nextBtn && renderNextBtn",nextBtn, renderNextBtn)
      if(nextBtn && renderNextBtn){
        nextBtn.innerHTML = renderNextBtn.innerHTML;
      }
      let deskClearAllBtns = document.querySelectorAll('.desktop-clear-facets-btn')
      let parsedDeskClearAllBtns = parsedHTML.querySelectorAll('.desktop-clear-facets-btn');
      deskClearAllBtns.forEach((deskClearAllBtn,i)=>{
          let parsedDeskClearAllBtn = parsedDeskClearAllBtns[i];
          let count = parseInt(parsedDeskClearAllBtn.dataset.count);
          if(count > 0){
            deskClearAllBtn.classList.remove('hidden')
          }else{
            deskClearAllBtn.classList.add('hidden')
          }
      })
      
    
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelectorAll(selector);
      activeFacetsElement.length > 0 && activeFacetsElement.forEach((el=>{
        if (el.closest('.category-wrapper') && qs('.category-wrapper .active-facets-desktop')) {
          qs('.category-wrapper .active-facets-desktop').innerHTML = el.innerHTML;
        }else {
          qs('[data-type="filter"] .active-facets-desktop').innerHTML = el.innerHTML;
        }
      }))
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        id: 'main-collection-product-grid',
        section: document.getElementById('main-collection-product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  /**
   * Merges current URL search params with form params so that the section fetch
   * always receives the full state (filters + sort). Form params override current URL.
   * This fixes sort (e.g. "Price, high to low") not applying when only the sort form
   * is submitted on desktop (other forms like filters may not be in the same wrapper).
   */
  static mergeSearchParams(formParamsString) {
    const current = new URLSearchParams(window.location.search.slice(1));
    const fromForms = new URLSearchParams(formParamsString || '');
    fromForms.forEach((value, key) => current.set(key, value));
    return current.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const formParams = this.createSearchParams(event.target.closest('form'));
      const searchParams = FacetFiltersForm.mergeSearchParams(formParams);
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      const formParams = forms.join('&');
      const searchParams = FacetFiltersForm.mergeSearchParams(formParams);
      this.onSubmitForm(searchParams, event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.priceFilter();
  }

  priceFilter = () => {
    let priceInputs = qsa('.price-range-js');
    if (priceInputs.length === 1000) {
      return;
    }
    priceInputs.forEach(item => {
      item.addEventListener('input', e => {
        let type = item.getAttribute('data-type');
        let targetClass = '.price-input-max-js';
        let value = item.value;
        let rangeStyle = '--range-max';
        let minValue = parseInt(qsa('.price-range-js')[0].value);
        let maxValue = parseInt(qsa('.price-range-js')[1].value);
        if (type == 'min') {
          targetClass = '.price-input-min-js';
          rangeStyle = '--range-min';
        }
        if (maxValue - minValue <= 2500) {
          if (type == 'min') {
            item.value = maxValue - 2500;
          }else{
            item.value = minValue + 2500;
          }
          return;
        }
        let targetInput = qs(targetClass);
        targetInput.value = value;

        item.closest('.range-slider').style.setProperty(rangeStyle, `${parseInt(value) / parseInt(item.max) * 100}%`);
        let clearFilter = qs('.clear-filter-js');
        if (clearFilter &&  clearFilter.classList.contains('d-none')) {
          clearFilter.classList.remove('d-none');
        }
      });
      item.addEventListener('change', e => {
        let type = item.getAttribute('data-type');
        let targetClass = '.price-input-max-js';
        if (type == 'min') {
          targetClass = '.price-input-min-js';
        }
        let targetInput = qs(targetClass);
        targetInput.dispatchEvent(new Event('input', {
          bubbles: true,
          cancelable: true,
        }));
      });
    })
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetsButtonsWrapper extends HTMLElement {
  constructor() {
    super();
    this.toggleFilter = qsa('.toggle-filter',this);
    this.toggleFilterContent = qsa('.toggle-filter-content',this);
    this.clickEvent();
  }
  clickEvent = () => {
    this.toggleFilter.length > 0 && this.toggleFilter.forEach(el=>{
      let dataFilter = el.getAttribute('data-filter');
      let filterContent = qs(`[data-type="${dataFilter}"]`);
      el.onmouseover = function(e) {
        filterContent.classList.add('filter-actiive');
      };
      el.onmouseout = function(e) {
        filterContent.classList.remove('filter-actiive');
      };
    })
    this.toggleFilterContent.length > 0 && this.toggleFilterContent.forEach(el=>{
      el.onmouseover = function(e) {
        el.classList.add('filter-actiive');
      };
      el.onmouseout = function(e) {
        el.classList.remove('filter-actiive');
      };
    })
  }
}

// customElements.define('facets-buttons-wrapper', FacetsButtonsWrapper)

const handleFacetClickEventMobile = () => {
  if (window.innerWidth < 990) {
  let sortBtn = qs('[data-filter="sort-by"]');
  sortBtn && sortBtn.addEventListener('click',(e)=>{
    qs('#FacetSortDrawerForm').classList.add('active');
    qs('body').classList.add('overflow-hidden');
  })

  document.addEventListener('click',(e)=> {
    if (e.target.closest('.mobile-close-sort-by')) {
      qs('#FacetSortDrawerForm').classList.remove('active')
      qs('body').classList.remove('overflow-hidden');
    }
  })

  document.addEventListener('input',(e)=> {
  if(e.target.getAttribute('name')=="sort_by")
    setTimeout(() => {
      qs('#FacetSortDrawerForm').classList.remove('active');
      qs('body').classList.remove('overflow-hidden');
    }, 1000);
  })

  qs('#FacetSortDrawerForm .facet-filters').addEventListener('click',(e)=> {
    if(e.target !== e.currentTarget) return;
    qs('#FacetSortDrawerForm').classList.remove('active')
    qs('body').classList.remove('overflow-hidden');
  })
}
}

window.onload = function(){ 
  var xsFilterOpenBtn = document.querySelector('.facet-summary-button.mobile-facets__open-wrapper');
  xsFilterOpenBtn?.addEventListener('click',(e)=>{
    let facets = document.querySelector('#FacetFiltersFormMobile')
    facets.dataset.active = "true";
    let header = document.querySelector('#sticky-header');
    if(header){
      header.classList.add('hidden')
    }
  })
  let xsFilterCloseBtns = document.querySelectorAll('.mobile-facets__close.mobile-facets__close--no-js')
  xsFilterCloseBtns.forEach((item)=>{
    item?.addEventListener('click',(e)=>{
      let facets = document.querySelector('#FacetFiltersFormMobile')
      facets.removeAttribute('data-active')
      let header = document.querySelector('#sticky-header');
      if(header){
        header.classList.remove('hidden')
      }
      document.body.classList.remove('overflow-hidden-mobile')
    })
  })
  let applyFilterBtns = document.querySelectorAll('.mobile-apply-filter')
  
  applyFilterBtns.forEach((item)=>{
    item?.addEventListener('click',(e)=>{
      let facets = document.querySelector('#FacetFiltersFormMobile')
      facets.removeAttribute('data-active')
      let header = document.querySelector('#sticky-header');
      if(header){
        header.classList.remove('hidden')
      }
      document.body.classList.remove('overflow-hidden-mobile')
    })
  })

  document.addEventListener('click',(e)=>{
    if(e.target.classList.contains('mobile-sorting-item')){
      let select = document.querySelector('.select__select');
      let target = e.target;
      let value = target.dataset.value;
      if(select){
        let event = new Event('input');
        select.value = value;
        let form = document.querySelector('#FacetFiltersFormMobile')
        if(form){
          form.dispatchEvent(event)
        }
      }
    }
    if(e.target.classList.contains('mobile-facets__submenu') || e.target.closest('.mobile-facets__submenu')){
      
    }else if(document.querySelector('.mobile-facets__details[open]')){
      let close = document.querySelector('.mobile-facets__details[open] .mobile-facets__close-button');
      if(close){
        if(window.innerWidth > 1024){
          close.click()
        }
      }
    }
  })
  handleFacetClickEventMobile();
};

  
